/**
 * @file export components
 * @author wangzixi@baidu.com
 */

import Table from './Table';
import TableRow from './TableRow';
import TableCell from './TableCell';
import TableHead from './TableHead';
import TableBody from './TableBody';
import TableFoot from './TableFoot';
import TableCollapse from './TableCollapse';
import TableMultiLevel from './TableMultiLevel';
import TableCheckable from './TableCheckable';

export { TableRow, TableCell, TableHead, TableBody, TableFoot, TableCollapse, TableMultiLevel, TableCheckable };
export default Table;